import React from 'react'
import { Modal } from 'react-bootstrap'
import PropTypes from 'prop-types'

export default class MEModal extends React.Component {
  render() {
    return (
      <Modal
        show={this.props.show}
        onHide={this.props.close}
        size={this.props.size}
      >
        <Modal.Header closeButton>
          <Modal.Title>{this.props.title}</Modal.Title>
        </Modal.Header>
        <Modal.Body>{this.props.children}</Modal.Body>
      </Modal>
    )
  }
}

MEModal.propTypes = {
  show: PropTypes.bool.isRequired,
  close: PropTypes.func.isRequired,
  title: PropTypes.string.isRequired,
  // react-bootstrap dialog size ('sm' | 'lg' | 'xl'); default width when omitted
  size: PropTypes.string,
}
